import React, { useEffect, useReducer } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Box, Typography, TextField, Button } from '@mui/material';
import Sidebar from '../../components/Sidebar/Sidebar';
import './MEE6GuildSettings.scss';

const initialState = { guild: null };

function reducer(state, action) {
  switch (action.type) {
    case 'FETCH_SUCCESS':
      return { ...state, guild: action.payload };
    case 'UPDATE_FIELD':
      return { ...state, guild: { ...state.guild, [action.field]: action.value } };
    default:
      throw new Error();
  }
}

const Settings = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { guildId } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('isha_token');
        const config = {
          headers: { Authorization: `${token}` },
        };
        const response = await axios.get(`/api/mee6_guilds/${guildId}`, config);
        dispatch({ type: 'FETCH_SUCCESS', payload: response.data.guild });
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [guildId]);

  if (!state.guild) {
    return <div>Loading...</div>;
  }

  const handleInputChange = (field) => (event) => {
    dispatch({ type: 'UPDATE_FIELD', field, value: event.target.value });
  };

  const renderPluginOptions = () => {
    const { plugins } = state.guild;

    return Object.entries(plugins).map(([pluginName, pluginData]) => (
      <Box key={pluginName} className="StyledCard_guildSettings">
        <Typography variant="h5">{pluginName} Plugin</Typography>
        {Object.entries(pluginData).map(([optionName, optionValue]) => (
          <TextField
            key={optionName}
            label={optionName}
            value={Array.isArray(optionValue) ? optionValue.join(', ') : optionValue}
            onChange={handleInputChange(`${pluginName}_${optionName}`)}
          />
        ))}
      </Box>
    ));
  };

  return (
    <Box className="StyledContainer">
      <Sidebar />
      <Box className="StyledContent">
        <Typography variant="h2">Settings for Guild ID: {guildId}</Typography>
        <Box className="StyledButtonContainer">{renderPluginOptions()}</Box>
        <Button variant="contained" color="primary">
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default Settings;
